module.exports = __webpack_public_path__ + "img/header_patinete.30860685.jpg";